import { useQuery } from "react-query";
import { articleSearch } from "../../Service/ArticleService";
import { queryKeys } from "./queryKeys";

function fetchKeywordResults(query, product) {
  const pathParams = {
    searchTerm: query,
    ...(product && { product }),
  };
  return articleSearch(query, pathParams).then((result) => {
    const raw =
      result?.data?.data?.articles ?? result?.data?.articles ?? [];
    return Array.isArray(raw) ? raw : [];
  });
}

/**
 * Keyword search results for /search page (GET article/search).
 * Runs when query is set (from URL ?q=).
 */
export function useKeywordSearchQuery(query, product) {
  return useQuery(
    queryKeys.keywordResults(query, product),
    () => fetchKeywordResults(query, product),
    {
      enabled: !!query?.trim(),
      staleTime: 2 * 60 * 1000,
    }
  );
}
